import * as Yup from "yup";

export interface LoginValues {
  email: string;
  password: string;
 
}

export const initialValues: LoginValues = {
  email: "",
  password: "",
  
};

export const loginValidationSchema = Yup.object().shape({
  password: Yup.string().required("password is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});
